import React, { useEffect, useState, useCallback } from "react";
import DropZone from "react-dropzone";
import { toast } from "react-toastify";
import { sizeConversion } from "../utils/GeneralUtils";

const Placeholder = ({
  getInputProps,
  getRootProps,
  noClick,
  noDrag,
  placeholder,
}: any) => (
  <div {...getRootProps()}>
    <input {...getInputProps()} />
    {placeholder ? (
      placeholder
    ) : (
      <p className="placeholderText">
        Drag files here or
        <span
          className={
            noClick || noDrag ? "placeHolderSpanDisabled" : "placeHolderspan"
          }
        >
          {" "}
          browse
        </span>
      </p>
    )}
  </div>
);

const FileDropZoneField = ({
  allowMultiple,
  acceptedFormats,
  displayAccepedFormats,
  noClick,
  noDrag,
  maxSize,
  input: { onChange },
  meta: { error, touched },
  disabled,
  placeholder,
  removeAllFiles,
}: any) => {
  const [errors, setErrors] = useState<any>();

  useEffect(() => {
    if (errors && errors?.length > 0) {
      errors.forEach((err: any) => {
        err?.errors?.forEach((each: any) => {
          if (each?.code === "file-too-large") {
            toast.error(
              `Failed to upload. Size limit is ${sizeConversion(maxSize)}.`
            );
          } else if (each?.code === "file-invalid-type") {
            toast.error(
              `Valid formats for file upload are ${acceptedFormats}.`
            );
          } else {
            toast.error(each?.message);
          }
        });
      });
      setErrors([]);
    }
  }, [acceptedFormats, errors, maxSize]);

  const deleteFile = useCallback(() => onChange(null), [onChange]);

  useEffect(() => {
    if (removeAllFiles) {
      removeAllFiles.current = deleteFile;
    }
  }, [deleteFile, removeAllFiles]);

  return (
    <div className="FileUploadContainer">
      {displayAccepedFormats && <span>Please upload {acceptedFormats} </span>}
      {disabled !== true && (
        <DropZone
          accept={acceptedFormats}
          onDrop={(file, e) => {
            onChange(file);
            e?.length > 0 && setErrors(e);
          }}
          multiple={allowMultiple}
          noClick={noClick}
          noDrag={noDrag}
          maxSize={maxSize}
          disabled={disabled}
        >
          {(props) => (
            <div className="fileUploadMainContainer">
              <div className="fileUpload">
                <div
                // className={
                //   noClick || noDrag
                //     ? "preview-container-diabled"
                //     : "preview-container"
                // }
                >
                  {" "}
                  <Placeholder
                    {...props}
                    error={error}
                    touched={touched}
                    noClick={noClick}
                    noDrag={noDrag}
                    placeholder={placeholder}
                  />{" "}
                </div>
              </div>
            </div>
          )}
        </DropZone>
      )}
    </div>
  );
};
export default FileDropZoneField;
